<template>
    <div>
        <div v-if="!loading">
            <div class="h-[170px] sm:h-[150px] md:h-[170px] lg:h-[190px] w-full relative overflow-hidden">
                <img :src="entry.image" @error="replaceBrokenImage" class="w-full h-full object-cover object-center" alt>
                <div class="h-[170px] sm:h-[150px] md:h-[170px] lg:h-[190px] w-screen px-2 absolute top-0 left-0 bg-white/80 flex align-items-center">
                    <div class="md:px-[40px] lg:px-[100px]">
                        <div class="relative h-fit mt-2 mb-3">
                            <div class="w-fit flex align-items-center sm:mb-2 sm:-mt-4 text-prime-color fill-prime-color hover:text-black hover:fill-black cursor-pointer" @click="()=>{this.$router.push({path: '/training'})}">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 sm:w-6 sm:h-6" viewBox="0 0 24 24" style="transform: ;msFilter:;">
                                    <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
                                </svg>
                                <h6 class="mb-0 font-semibold text-xl">Tất cả ngành học</h6>
                            </div>
                            <h3 class="ml-1 text-2xl md:text-3xl font-semibold w-fit text-justify header-underline pb-[6px] sm:pb-2 drop-shadow-2xl shadow-white">
                                {{ entry.name }}
                            </h3>
                            <span class="sm:ml-1 absolute w-1/3 max-w-[60px] h-[3px] md:h-[4px] bg-blue-600 bottom-0 rounded-r-xl"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content md:px-[40px] lg:px-[100px] relative">
                <p class="text-lg md:text-xl text-justify" v-html="entry.description"></p>
                <div class="relative h-fit mt-6">
                    <h3 class="text-xl md:text-2xl font-semibold w-fit text-justify header-underline pb-[6px] sm:pb-2">Các ngành học khác</h3>
                    <span class="absolute w-1/3 max-w-[60px] h-[3px] md:h-[4px] bg-blue-600 bottom-0 rounded-r-xl"></span>
                </div>
                <vue-horizontal-list :items="listCourse" :options="options">
                    <template v-slot:nav-next class="bg-transparent">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>
                        </div>
                    </template>
                    <template v-slot:nav-prev>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg>
                        </div>
                    </template>
                    <template v-slot:default="{ item }">
                        <div class="item relative">
                            <div class="bg-white w-full h-[280px] border-[1px] border-black hover:border-orange-400 relative rounded-2xl overflow-hidden course-card transition-all duration-300">
                                <img @error="replaceBrokenImage" :src="$addPrefix(item.image)" loading="lazy" class="w-full h-[250px] object-cover object-center cursor-pointer">
                                <div class="bg-white h-fit px-[8px] py-3 md:px-3 flex flex-col rounded-tl-2xl absolute bottom-0 left-0 right-0 course-content">
                                    <h5 class="mb-0 text-xl font-semibold truncate capitalize text-black">{{ item.name }}</h5>
                                    <h6 class="mb-0 text-lg font-medium capitalize text-black">{{ item.type }}</h6>
                                    <p class="w-full line-clamp-3 mt-2 pt-1 border-t-[1px] border-white" v-html="item.description"></p>
                                    <p @click="pushCourseDetail(item._id)" class="mb-0 pr-2 mt-2 text-right hover:text-prime-color cursor-pointer font-semibold">Tìm hiểu ngay</p>
                                    <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path></path></svg>
                                </div>
                            </div>
                        </div>
                    </template>
                </vue-horizontal-list>
            </div>
        </div>
        <Loading class="box-content" v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import VueHorizontalList from 'vue-horizontal-list';
import Loading from '@/components/loading'
export default {
    components: {
        VueHorizontalList, 
        Loading
    },
    data() {
        return {
            entry: [],
            listCourse: [],
            uniCourses: [],
            afterUniCourses: [],
            transferUniCourses: [],
            shortCourses: [],
            options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { start: 992, end: 1280, size: 4 },
                { size: 5 },
                ],
                list: {
                windowed: 1280,
                padding: 24,
                },
                position: {
                start: 1,
                },
                autoplay: { play: true, repeat: true, speed: 4000 },
            },
            loading: true
        };
    },
    methods: {
        ...mapActions('course', ['GetCourseList', 'GetCourse']),
        async getEntry() {
            this.loading = true
            let respon1 = await this.GetCourse(this.$route.params.id)
            this.entry = respon1.data
            this.loading = false
        },
        async getCourseList() {
            let respone2 = await this.GetCourseList()
            for (let index in respone2.data) {
                switch (respone2.data[index].type) {
                    case 'Hệ đại học':
                        this.uniCourses.push(respone2.data[index]);
                        break;
                    case 'Hệ cao học':
                        this.afterUniCourses.push(respone2.data[index]);
                        break;
                    case 'Liên thông đại học':
                        this.transferUniCourses.push(respone2.data[index]);
                        break;
                    case 'Khóa học ngắn hạn':
                        this.shortCourses.push(respone2.data[index]);
                        break;
                }
            }
            this.listCourse = this.uniCourses.concat(this.afterUniCourses).concat(this.transferUniCourses).concat(this.shortCourses)
        },
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/home/home-footer.jpg");
		},
        pushCourseDetail(id) {
            if (id != this.$route.params.id) {
                this.$router.push({path: '/training/detail/' + id})
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        }
    },
    created() {
        this.getEntry()
        this.getCourseList()
    },
    watch: {
        '$route.params.id': {
            handler: function() {
                this.getEntry()
            }
        }
    }
    
}
</script>
<style lang="scss">
.course-card{
    .course-content {
        color: white;
        transition: all ease-in 300ms;
        transform: translateY(120px);
    }
}
.course-card:hover {
    .course-content {
        transform: translateY(0px);
        color: black;
        .border-white {
            border-color: rgb(194, 194, 194) !important;
        }
    }
}
</style>
<style scoped>
.card__arc {
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 99%;
  right: 0;      
  z-index: 1;
}
.card__arc path {
  fill: white;
  /* d: path("m 40 80 c 22 0 40 -22 40 -40 v 40 z"); */
  d: path("m 20 40 c 11 0 20 -11 20 -20 v 20 z");
}
</style>